import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  rectangle: {
    width: 5,
    height: 18,
    marginRight: '0.5rem',

    background: theme.palette.primary.main,
    borderRadius: '0px 8px 8px 0px',
    transform: 'matrix(1, 0, 0, -1, 0, 0)'
  }
}))

export default useStyles
